import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, CalendarCheck, HeartPulse, Shuffle, Ambulance, Zap } from 'lucide-react';
export function Benefits() {
  const benefits = [{
    icon: ShieldCheck,
    title: 'Cocinar con más seguridad',
    description: 'Sabrás qué ingredientes puedes usar, cuáles limitar y cuáles nunca darle a tu perro antes de preparar cualquier receta.'
  }, {
    icon: CalendarCheck,
    title: 'Organizarte mejor cada semana',
    description: 'Tendrás un planificador para saber qué preparar, qué comprar y cómo adelantar la cocina sin improvisar.'
  }, {
    icon: HeartPulse,
    title: 'Conocer mejor a tu perro',
    description: 'Con el diario de tolerancia podrás registrar cómo responde tu perro a cada ingrediente nuevo y crear tu propia lista segura personalizada.'
  }, {
    icon: Shuffle,
    title: 'Adaptar recetas fácilmente',
    description: 'Si te falta un ingrediente, las tarjetas de sustitución te ayudarán a reemplazarlo de forma más segura sin tener que buscar en internet.'
  }, {
    icon: Ambulance,
    title: 'Estar preparado ante emergencias',
    description: 'Con el Kit SOS tendrás pasos claros, ficha de emergencia y guion listo para actuar rápido si tu perro come algo peligroso.'
  }, {
    icon: Zap,
    title: 'Empezar hoy mismo',
    description: 'Todo el pack es digital y descargable. Puedes tenerlo en tu celular, tablet o computadora en minutos y empezar a usarlo hoy.'
  }];
  return <section className="py-20 px-4 bg-brand-cream" data-id="element-32">
      <div className="max-w-6xl mx-auto" data-id="element-33">
        <div className="text-center mb-16" data-id="element-34">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-navy mb-4" data-id="element-35">
            Lo que este pack puede ayudarte a lograr:
          </h2>
          <div className="w-24 h-1 bg-brand-orange mx-auto rounded-full" data-id="element-36"></div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-37">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-8 rounded-3xl shadow-sm hover:shadow-md transition-shadow border border-gray-100" data-id="element-38">
              <div className="bg-brand-beige w-14 h-14 rounded-2xl flex items-center justify-center mb-6" data-id="element-39">
                <benefit.icon className="w-7 h-7 text-brand-orange" data-id="element-40" />
              </div>
              <h3 className="text-xl font-bold text-brand-navy mb-3" data-id="element-41">
                {benefit.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-42">
                {benefit.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}